import { render, staticRenderFns } from "./TableBusiness.vue?vue&type=template&id=ff2cfa5e&scoped=true"
import script from "./TableBusiness.vue?vue&type=script&lang=js"
export * from "./TableBusiness.vue?vue&type=script&lang=js"
import style0 from "./TableBusiness.vue?vue&type=style&index=0&id=ff2cfa5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2cfa5e",
  null
  
)

export default component.exports